// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3V_Y5","header":"ReportDetails_header__2uBrw","title":"ReportDetails_title__g8WbF","left":"ReportDetails_left__2B3vo"};